import Marquee from "react-fast-marquee";
import { Droplets, KeyRound, Zap, Clock, ShieldCheck, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: Droplets, label: "Plomberie d'urgence" },
  { icon: KeyRound, label: "Serrurerie 24/7" },
  { icon: Zap, label: "Électricité & dépannage" },
  { icon: Clock, label: "Intervention en 30 min" },
  { icon: ShieldCheck, label: "Devis gratuit" },
  { icon: BadgeCheck, label: "Artisans certifiés" },
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="border-y border-slate-200 bg-slate-50 py-5 overflow-hidden">
      <Marquee speed={45} gradient gradientColor="#F8FAFC" gradientWidth={80} autoFill>
        {ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <div key={i} className="flex items-center gap-2.5 mx-8 text-ink-soft">
              <Icon className="h-5 w-5 text-brand" />
              <span className="font-semibold whitespace-nowrap">{item.label}</span>
              <span className="ml-8 h-1.5 w-1.5 rounded-full bg-brand-green" />
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
